import React from 'react';
import UserState from 'context/User/UserState';
import MessengerState from 'context/Messenger/MessengerState';
import { AppState } from 'context';
import NotificationState from './Notification/NotificationState';

const MainContextProvider = ({ children }) => (
  <AppState>
    <UserState>
      <NotificationState>
        <MessengerState>{children}</MessengerState>
      </NotificationState>
    </UserState>
  </AppState>
);

export default MainContextProvider;
